<template>
  <section v-if="hasProducts" class="">
    <div class="section__header pb-0">
      <div class="container-lg">
        <h2 class="mb-[13px] text-heading-2">
          {{ slider.title }}
          <span
              :class="[theme === 'green' && 'text-lime-green ', theme === 'pink' && 'text-hot-pink ', theme === 'amber' && 'text-amber ',theme === 'sky' && 'text-sky-blue ']">
            {{ slider.highlighted_title }}
          </span>
        </h2>
        <h4 class="md:mb-[24px] !font-light text-[16px]">{{ slider.sub_title }}</h4>
        <div class="w-full md:hidden mb-[24px]">
          <a :href="slider.link" class="text-[16px] font-semibold underline">{{ in18['page_view_all'] }}</a>
        </div>
        <!-- Line after subtitle -->
        <div class="w-full h-1 mb-[44px] border-b border-light-gray/25">
          <div class="w-[56%] md:w-[19%] h-1"
               :class="[theme === 'green' && 'bg-lime-green ', theme === 'pink' && 'bg-hot-pink ', theme === 'amber' && 'bg-amber ',theme === 'sky' && 'bg-sky-blue ']">
          </div>
        </div>

        <div class="flex flex-col md:flex-row gap-[16px] md:h-[400px]">
          <div
              class="hidden md:block rounded-[8px] h-full aspect-[34/39] flex-shrink-0 relative shadow-base-narrow border border-charcoal/[7%]">
            <img :src="slider.image_background.webp" :srcset="slider.image_background.source"
                 class="inset-0 w-full h-full object-cover bg-cover rounded-[8px]" :alt="slider.title">

            <div class="absolute bottom-0 right-0 top-[-25px] left-[-45px] z-[1]">
              <img :src="slider.image.webp" :srcset="slider.image.source"
                   class="inset-0 w-full h-full object-cover bg-cover" :alt="slider.title">
            </div>

            <a :href="slider.link" role="button"
               class="block absolute text-center z-[2] bottom-[30px] left-[24px] right-[24px] py-4 text-white text-[15px] font-semibold rounded-[8px] transition-all "
               :class="[theme === 'green' && 'bg-lime-green hover:bg-lime-green-hover', theme === 'pink' && 'bg-hot-pink hover:bg-hot-pink-hover', theme === 'amber' && 'bg-amber hover:bg-amber-hover',theme === 'sky' && 'bg-sky-blue hover:bg-sky-blue-hover']">
              {{ in18['page_view_all'] }}
            </a>
          </div>

          <div
              class="h-full md:flex-grow md:h-[calc(100%+40px)] flex flex-col min-w-0 md:-mr-[12px] md:my-[-20px] md:justify-center">
            <div :id="type" :data-category-slider="type" :data-slider="type"
                 class="products-slider  overflow-hidden my-auto ">
              <div v-for="product in slider.products" :key="product.id" class="w-full px-[5px]">
                <product-item :product="product" :color-variant="theme" class="!h-[400px]"/>
              </div>
            </div>
          </div>
        </div>

        <div class="pt-[22px] pb-4 flex justify-end gap-[8px] md:pr-[12px]">
          <button
              :data-slick-arrows-for="'#' + type"
              :title="in18['page_previous']"
              class="slider__arrows-previous bg-gray h-[36px] rounded-[5px] w-[36px] text-black transition-all  hover:bg-light-gray"
              type="button"
          >
            <img src="/shop/images/arrow-down-white.svg" class="rotate-[90deg] mx-auto my-auto" alt="previous arrow">
          </button>
          <button
              :data-slick-arrows-for="'#' + type"
              :title="in18['page_next']"
              class="slider__arrows-forward bg-gray h-[36px] rounded-[5px] w-[36px] text-black transition-all  hover:bg-light-gray"
              type="button"
          >
            <img src="/shop/images/arrow-down-white.svg" class="rotate-[-90deg] mx-auto my-auto" alt="next arrow">
          </button>
        </div>
      </div>
    </div>
  </section>


</template>

<script setup>
import {ref, computed, onMounted} from 'vue';
import axios from 'axios';
import $ from 'jquery';

// Props
const props = defineProps({
  type: String,
  in18: Object,
  data: Object,
});

// Reactive variables
const slider = ref({});

// Computed property
const hasProducts = computed(() => {
  return slider.value?.products?.length > 0;
});

const theme = computed(() => {
  if (slider.value && slider.value.highlighted_color && ['green',
    'pink',
    'amber',
    'sky'].includes(slider.value.highlighted_color)) {
    return slider.value.highlighted_color;
  }
  return 'green'; // green, pink, amber, sky
})

// Fetch slider data
const fetchSliderData = () => {
  const params = props.data ? `?${new URLSearchParams(props.data).toString()}` : '';
  axios(`/api/slider/${props.type}${params}`)
      .then((response) => {
        slider.value = response.data.slider;
        // console.log(slider.value);
        ga_view_item_list_event(response.data.slider.products);
      })
      .finally(() => {
        if (hasProducts.value) {
          activateSlick();
        }
      });
};

// Activate the Slick slider
const activateSlick = () => {
  $(`[data-category-slider='${props.type}']`).slick({
    infinite:       true,
    slidesToShow:   3,
    slidesToScroll: 1,
    arrows:         false,
    dots:           false,
    speed:          600,
    lazyLoad:       'ondemand',
    autoplay:       true,
    autoplaySpeed:  3000,
    responsive:     [
      {
        breakpoint: 1200,
        settings:   {slidesToShow: 2},
      },
      {
        breakpoint: 840,
        settings:   {slidesToShow: 2},
      },
      {
        breakpoint: 800,
        settings:   {slidesToShow: 1},
      },
      {
        breakpoint: 768,
        settings:   {slidesToShow: 2},
      },
      {
        breakpoint: 500,
        settings:   {slidesToShow: 1},
      },
    ],
  });

  $('.slider__arrows-previous').on('click', function () {
    const sliderSelector = $(this).data('slick-arrows-for');
    $(sliderSelector).slick('slickPrev');
  });

  $('.slider__arrows-forward').on('click', function () {
    const sliderSelector = $(this).data('slick-arrows-for');
    $(sliderSelector).slick('slickNext');
  });
};

// Lifecycle hook
onMounted(() => {
  fetchSliderData();
});
</script>

<style>
.slick-list.draggable {
  margin-top: auto;
  margin-bottom: auto;
}

</style>
